import BasicContactForm from './BasicContactForm';

export default BasicContactForm;
